/**
 * Condivisione WhatsApp con allegato PDF.
 * - Mobile/iPad: Web Share API Level 2 → share sheet nativo con file allegato
 *   (l'utente sceglie WhatsApp e il PDF è già allegato).
 * - Fallback: download del PDF + apertura wa.me (si aggancia all'app WhatsApp
 *   anche su iPad, a differenza di web.whatsapp.com).
 */
import { toast } from "sonner";

const cleanPhone = (phone) => (phone || "").replace(/[^0-9]/g, "");

export function openWhatsAppText(text, phone) {
  const p = cleanPhone(phone);
  const url = p
    ? `https://wa.me/${p}?text=${encodeURIComponent(text)}`
    : `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(url, "_blank");
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

/** Ritorna true se il dispositivo supporta la condivisione nativa di file (Web Share L2). */
export function canShareFiles() {
  try {
    const f = new File(["x"], "t.pdf", { type: "application/pdf" });
    return !!(navigator.canShare && navigator.canShare({ files: [f] }));
  } catch {
    return false;
  }
}

/** Apre il pannello di condivisione nativo del telefono/iPad con il file già allegato
 *  e già nominato. Ritorna "shared" | "aborted" | "fallback" (download). */
export async function shareFileNative({ blob, filename, title, text }) {
  const file = new File([blob], filename, { type: blob.type || "application/pdf" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: title || filename, ...(text ? { text } : {}) });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "aborted";
    }
  }
  downloadBlob(blob, filename);
  toast.info("Condivisione non disponibile — PDF scaricato");
  return "fallback";
}

/** Ritorna "shared" | "aborted" | "fallback" */
export async function shareWhatsAppWithPdf({ text, blob, filename = "documento.pdf", phone }) {
  const file = new File([blob], filename, { type: "application/pdf" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: filename, text });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "aborted";
      // NotAllowedError o altro → prosegui col fallback
    }
  }
  downloadBlob(blob, filename);
  openWhatsAppText(`${text}\n(PDF scaricato — allegalo al messaggio)`, phone);
  toast.info("PDF scaricato — allegalo nella chat WhatsApp appena aperta");
  return "fallback";
}
